const data = {
  api: ""// ""//"http://eformservice.com:5200"// http://localhost:5200
};

export default data;


// WEBPACK FOOTER //
// ./src/config.js